// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M11.5,5h1v7.5H7v-1h4.5V5z M22,12c0,5.5-4.5,10-10,10S2,17.5,2,12S6.5,2,12,2S22,6.5,22,12z M21,12c0-5-4-9-9-9s-9,4-9,9
		s4,9,9,9S21,17,21,12z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-clock-BBelwG_8.js.map
